import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ImageInputComponent} from "@cybfed/ui-lib/forms/image-input/image-input.component";
import {IconModule} from "../../../../../../../../../shared/assets/icons/ts/icon.module";
import {InputComponent} from "@cybfed/ui-lib/forms/text-inputs/input/input.component";
import {TranslateModule} from "@ngx-translate/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {appConstants} from "@cybfed/constants";
import {ButtonComponent} from "@white-label/components/white-label/button/button.component";
import {InputRangeComponent} from "@cybfed/ui-lib/forms/text-inputs/input-range/input-range.component";
import {NgIf} from "@angular/common";
import {EFileTypes} from "@cybfed/ui-lib/forms/image-input/media-gallery/file-uploader/file-uploader.component";
@Component({
    selector: 'white-label-sticker-ad-edit',
    standalone: true,
    imports: [
        ImageInputComponent,
        IconModule,
        InputComponent,
        TranslateModule,
        ButtonComponent,
        InputRangeComponent,
        NgIf
    ],
    templateUrl: './sticker-ad-edit.component.html'
})
export class StickerAdEditComponent implements OnInit, OnChanges{
    bannerSizes: any = appConstants.IMAGESIZES
    @Input() item: any;
    @Input() currency: any;
    @Output() onDelete = new EventEmitter();
    @Output() onCancelEdit = new EventEmitter();
    @Output() onSave = new EventEmitter();
    stickerForm: FormGroup = new FormGroup({
        mediaUrl: new FormControl('', [Validators.required]),
        price: new FormControl(10, [Validators.required]),
        duration: new FormControl(10, [Validators.required]),
    });
    productImage: any;
    constructor(
    ) { }

    ngOnInit(): void {

    }

    cancelEdit() {
        this.stickerForm.reset({
            mediaUrl: '',
            price: 10,
            duration: 10
        });
        this.productImage = null;
        this.item = null;
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes['item'] && this.item) {
            this.updateFormWithItem();
        }
    }

    updateFormWithItem() {
        this.stickerForm.patchValue({
            mediaUrl: this.item.media?.mediaUrl || '',
            price: this.item.price || 10,
            duration: this.item.duration || 10
        });

        this.productImage = { s3Url: this.item.media?.mediaUrl || '' };
    }

    setImage(event: any) {
        this.productImage = event[0];
        this.stickerForm.controls['mediaUrl'].patchValue(this.productImage.s3Url);
    }


    save(){
        this.onSave.emit(this.stickerForm.value)
    }

    removeItem(){
        this.onDelete.emit(this.item._id)
    }

    protected readonly EFileTypes = EFileTypes;
}
